import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'email-templates/create',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./CreateEmailTemplate').default
      callback(null, component)
    }, 'CreateEmailTemplate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/CreateEmailTemplate/index.js